import './Navbar.css';

function Navbar({ items }) {
  return (
    <header className="navbar">
      <nav className="navbar__content" aria-label="Main navigation">
        {items.map((item) => (
          <a href={`#${item.target}`} key={item.target}>
            {item.label}
          </a>
        ))}
      </nav>
    </header>
  );
}

export default Navbar;
